<div class="map-list-loader" *ngIf="loader">
    <img alt="Please wait while loading..." style="height:140px" class="img-fluid" src="assets/images/loader.gif">
</div>


<div class="container-fluid basic-info-holder" id="price">
    <div class="container">
        <div class="col-md-12 breaeea" *ngIf="data && data.property_type>0">

            <ul class="breadcrumb">
                <li><a href="#">Home</a></li>
                <li *ngIf="data.property_type=='1'"><a routerLink="/search/rent">Rent</a></li>
                <li *ngIf="data.property_type=='2'"><a routerLink="/search/buy">Buy</a></li>
                <li *ngIf="data.property_type=='3'"><a routerLink="/search/pg">PG</a></li>
                <li *ngIf="data.property_type=='1' && data.looking_type=='1' "><a routerLink="/search/rent/residential">Residential</a></li>
                <li *ngIf="data.property_type=='1' && data.looking_type=='2' "><a routerLink="/search/rent/commercial">Commercial</a></li>
                <li *ngIf="data.property_type=='1' && data.looking_type=='3' "><a routerLink="/search/rent/agriculture">Agriculture</a></li>
                <li *ngIf="data.property_type=='1' && data.looking_type=='4' "><a routerLink="/search/rent/industry">Industry</a></li>
                <li *ngIf="data.property_type=='2' && data.looking_type=='1' "><a routerLink="/search/buy/residential">Residential</a></li>
                <li *ngIf="data.property_type=='2' && data.looking_type=='2' "><a routerLink="/search/buy/commercial">Commercial</a></li>
                <li *ngIf="data.property_type=='2' && data.looking_type=='3' "><a routerLink="/search/buy/agriculture">Agriculture</a></li>
                <li *ngIf="data.property_type=='2' && data.looking_type=='4' "><a routerLink="/search/buy/industry">Industry</a></li>
                <li>{{ data.title_first }} {{ data.title_second }}</li>
            </ul>

        </div>
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                <div class="property-specification" style="margin-bottom: 10px;">
                    <div class="row">
                        <div class="col-lg-4 col-xl-4 col-md-12 col-12  property-single-image" id="detail" *ngIf="data.images">
                            <div class="main-img-slider h-100">
                                <a class="h-100" *ngFor="let images of data.images" data-fancybox="gallery" href="{{ images.img_path }}"><img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ images.img_path }}" alt="property image"></a>
                            </div>
                            <div class="ribbon verified" *ngIf="data.property_type=='2'">
                                <span>For Sale</span>
                            </div>
                            <div class="ribbon verified" *ngIf="data.property_type=='1'">
                                <span>For Rent</span>
                            </div>
                            <div class="ribbon verified" *ngIf="data.property_type=='3'">
                                <span>For PG</span>
                            </div>
                            <div class="image-overlay"></div>
                            <span class="media-file"> <i class="ti-camera"></i>
                                {{data.images.length}}</span>
                        </div>

                        <!-- show data for rent and sell-->
                        <div class="col-lg-8 col-xl-8 col-12 pt-3 pt-lg-0" *ngIf="data.property_type=='1' || data.property_type=='2'">
                            <div class="row marginZero">
                                <div class="col-12">
                                    <div class="row align-items-center d-flex" [ngClass]="data.sold_status==0 ? 'justify-content-center' : ''">
                                        <div class="col-lg-8 col-xl-8 col-md-8 col-12 pl-0 property-name-add">
                                            <div class="property-price headTitel">
                                                <b style="font-size:20px">{{ data.title_first }}</b>{{ data.title_second }}
                                                <h1 class="seo-none-my ">{{ data.title_first }} {{ data.title_second }}</h1>
                                                <div class="title-inline-part mt-2">
                                                    <span class="property-status whatsnearby" *ngIf="data.nearby_area">Near by
                                                        Area: {{ data.nearby_area }}</span>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="col-lg-4 col-xl-4 col-md-4 col-12 property-cta pr-0 d-none d-md-block" *ngIf="!data.propertyof_user && data.sold_status==0">

                                            <a style="cursor: pointer;" class="btn-small pc-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                                Now</a>

                                            <a style="cursor: pointer;" class="btn-small mobile-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                                Now</a>
                                            <span class="wishlist-btn">
                                                <i class="testsss fa" id="latesetwishlist"
                                                    [ngClass]="chkPropertyWishlistId.includes(data.property_id) ? 'fa-heart':'fa-heart-o'"
                                                    (click)="addToWishlist(data.property_type,data.property_id,$event)"></i>
                                                <i class="fa fa-spinner fa-spin" id="latesetloader"
                                                    style="color:red;display:none"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 px-0 property-name-add">
                                    <div class="row align-items-center d-flex">
                                        <div class="col-6 col-md-12">
                                            <div class="row align-items-center d-flex py-2">
                                                <div class="col-12 col-md-6">
                                                    <div class="property-price priceTitel" *ngIf="data.property_type=='2'">
                                                        <h4>₹{{ data.priceinshort_words }}
                                                            <small>₹{{ data.priceper_unitvalue }}</small>
                                                        </h4>
                                                    </div>
                                                    <div class="property-price" *ngIf="data.property_type=='1'">
                                                        <h4>₹{{ data.priceper_unitvalue }}</h4>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 text-left text-md-right mt-2 mt-md-0">
                                                    <div class="propertyType">
                                                        <h2 *ngIf="data.source_type=='1'">Bro<span>ker</span></h2>
                                                        <h2 *ngIf="data.source_type=='2' || data.source_type=='3'">Ow<span>ner</span></h2>
                                                        <h2 *ngIf="data.source_type=='4'">Certified <span>Agent</span></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 d-md-none text-right">
                                            <div class="col-lg-4 col-xl-4 col-md-4 col-12 property-cta pr-0" *ngIf="!data.propertyof_user && data.sold_status==0">

                                                <a style="cursor: pointer;" class="btn-small pc-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                                Now</a>

                                                <a style="cursor: pointer;" class="btn-small mobile-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                                Now</a>
                                                <span class="wishlist-btn">
                                                <i class="testsss fa" id="latesetwishlist"
                                                    [ngClass]="chkPropertyWishlistId.includes(data.property_id) ? 'fa-heart':'fa-heart-o'"
                                                    (click)="addToWishlist(data.property_type,data.property_id,$event)"></i>
                                                <i class="fa fa-spinner fa-spin" id="latesetloader"
                                                    style="color:red;display:none"></i>
                                            </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row marginZero">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-title-section">
                                    <div class="row">
                                        <div class="col-lg-8 col-xl-8 col-md-8 col-sm-7 col-12">
                                            <div class="title-inline-part"><i class="ti-calendar"></i> {{ data.created_date | date:'MMMM dd yyyy'}}</div>
                                            <div class="title-inline-part">
                                                <span class="property-whishlist-wrapper">
                                                    <a href="javascript:void(0)" class="property-whishlist">
                                                        <i class="ti-heart"></i> {{ data.total_wishlist }}
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="title-inline-part">
                                                <i class="ti-eye" aria-hidden="true"></i> {{ data.total_view }}
                                            </div>
                                            <div class="title-inline-part" *ngIf="data.sold_status==0">
                                                <ul class="post-share">
                                                    <li>Share On</li>
                                                    <li class="wtsp"><a href="javascript: void(0);" (click)="sharePost('google',data.property_slug)"><i
                                                                class="fa  fa-google"></i></a></li>
                                                    <li class="fb-icon"><a href="javascript:void(0)" (click)="sharePost('facebook',data.property_slug)"><i
                                                                class="ti-facebook"></i></a></li>
                                                    <li class="instagram-icon"><a href="javascript:void(0)" (click)="sharePost('instagram',data.property_slug)"><i
                                                                class="ti-instagram"></i></a></li>
                                                    <li class="wtsp"><a href="javascript:void(0)" (click)="sharePost('whatsup',data.property_slug)"><i
                                                                class="fa fa-whatsapp"></i></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-xl-4 col-md-4 col-sm-5 col-12 text-right propID align-items-center d-flex justify-content-start justify-content-sm-end">
                                            <div class="title-id"><b>Property ID: {{ data.propertyid_no }}</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row marginZero fix-third-row">

                                <div class="property-param room" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9')) || (data.property_type=='1' && (data.looking_subcat_type=='1')) || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'))">
                                    <span class="property-content">
                                        <span class="property-label">Room</span>
                                    <span class="property-value">
                                            <span>{{ data.room }}</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param attach-bath" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9')) || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'))">
                                    <span class="property-content">
                                        <span class="property-label">Bathroom</span>
                                    <span class="property-value">
                                            <span>{{ data.baathroom }}</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param super-area">
                                    <span class="property-content">
                                        <span class="property-label"
                                            *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6'))">Super
                                            Area</span>
                                    <span class="property-label" *ngIf="data.looking_subcat_type=='8' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13' ">Land
                                            Area</span>
                                    <span class="property-label" *ngIf="(data.looking_subcat_type=='2' || data.looking_subcat_type=='4' || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6')) || data.looking_subcat_type=='7')">Area</span>
                                    <span class="property-value">
                                            <span
                                                *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5'  || data.looking_subcat_type=='6'))">{{
                                                data.super_area}}</span>
                                    <span *ngIf="(data.looking_subcat_type=='2' || data.looking_subcat_type=='4' || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6')) || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">{{
                                                data.area }}</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param status" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1'  || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9' || data.looking_subcat_type=='13')) || (data.property_type=='1' && (data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='13'))">
                                    <span class="property-content">
                                        <span class="property-label">Possesion Status</span>
                                    <span class="property-value">
                                            <span>{{ data.possession_status_name }}</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param transaction-type" *ngIf="data.property_type=='2' && (data.looking_subcat_type=='1'  || data.looking_subcat_type=='5'  || data.looking_subcat_type=='6'  || data.looking_subcat_type=='9'  || data.looking_subcat_type=='13')">
                                    <span class="property-content">
                                        <span class="property-label">Transaction Type</span>
                                    <span class="property-value">
                                            <span *ngIf="data.transaction_type=='1'">Resale</span>
                                    <span *ngIf="data.transaction_type=='2'">New Property</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param extra-charges" *ngIf="(data.property_type=='1' && (data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'))">
                                    <span class="property-content">
                                        <span class="property-label">Extra Charges</span>
                                    <span class="property-value">
                                            <span *ngIf="data.extra_charge_apply=='1'">Yes</span>
                                    <span *ngIf="data.extra_charge_apply=='0'">No</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param facing-road" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='4' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')) || (data.property_type=='1' && (data.looking_subcat_type=='2' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13'))">
                                    <span class="property-content">
                                        <span class="property-label">Width of facing Road</span>
                                    <span class="property-value">
                                            <span>{{ data.width_facing_road }} Foot</span>
                                    </span>
                                    </span>
                                </div>


                                <div class="property-param furnishing" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1'  || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9')) || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'))">
                                    <span class="property-content">
                                        <span class="property-label">Furnishing</span>
                                    <span class="property-value">
                                            <span *ngIf="data.feature_furnished=='1'">
                                                Furnished</span>
                                    <span *ngIf="data.feature_furnished=='2'">
                                                Non-Furnished</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param facing" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='4' || data.looking_subcat_type=='5' || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='9' || data.looking_subcat_type=='13')) || (data.property_type=='1' && (data.looking_subcat_type=='7' || data.looking_subcat_type=='13'))">
                                    <span class="property-content">
                                        <span class="property-label">Facing</span>
                                    <span class="property-value">
                                            <span>{{ data.facing }}</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param ownership" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='4' || data.looking_subcat_type=='7'  || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')) || (data.property_type=='1' && (data.looking_subcat_type=='10')) ">
                                    <span class="property-content">
                                        <span class="property-label">Ownership by</span>
                                    <span class="property-value">
                                            <span>{{ data.property_ownership }}</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param boundary" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='10')) || (data.property_type=='1' && (data.looking_subcat_type=='7')) || (data.property_type=='1' && (data.looking_subcat_type=='10' || data.looking_subcat_type=='13')) ">
                                    <span class="property-content">
                                        <span class="property-label">Boundary</span>
                                    <span class="property-value">
                                            <span *ngIf="data.boundary=='1'">Yes</span>
                                    <span *ngIf="data.boundary=='0'">No</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param water-supply" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='8' || data.looking_subcat_type=='10')) || (data.property_type=='1' && (data.looking_subcat_type=='7' || data.looking_subcat_type=='10'))">
                                    <span class="property-content">
                                        <span class="property-label">Water Supply</span>
                                    <span class="property-value">
                                            <span *ngIf="data.feature_watersupply=='0'">No</span>
                                    <span *ngIf="data.feature_watersupply=='1'">Yes</span>
                                    </span>
                                    </span>
                                </div>


                                <div class="property-param power-backup" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='8' || data.looking_subcat_type=='10')) || (data.property_type=='1' && (data.looking_subcat_type=='7' || data.looking_subcat_type=='10'))">
                                    <span class="property-content">
                                        <span class="property-label">Electricity Connection</span>
                                    <span class="property-value">
                                            <span *ngIf="data.feature_electricityconnection=='0'">No</span>
                                    <span *ngIf="data.feature_electricityconnection=='1'">Yes</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param flooring" *ngIf="((data.property_type=='1' && data.looking_subcat_type=='1') || (data.property_type=='2' && (data.looking_subcat_type=='5' || data.looking_subcat_type=='6')  && data.want_tosell=='1'))">
                                    <span class="property-content">
                                        <span class="property-label">Property on Which Floor</span>
                                    <span class="property-value">
                                            <span class="spec-item-value"
                                                *ngIf="data.property_which_floors=='-1'">Basement</span>
                                    <span class="spec-item-value" *ngIf="data.property_which_floors=='0'">Ground</span>
                                    <span class="spec-item-value" *ngIf="data.property_which_floors>'0'">{{
                                                data.property_which_floors }}</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param flooring" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='2'))">
                                    <span class="property-content">
                                        <span class="property-label">Constructed Floor</span>
                                    <span class="property-value">
                                            <span>{{ data.constructed_floors=='0' ? 'Ground' : data.constructed_floors
                                                }}</span>
                                    </span>
                                    </span>
                                </div>




                                <div class="property-param shade" *ngIf="(data.looking_subcat_type=='13')">
                                    <span class="property-content">
                                        <span class="property-label">Shade</span>
                                    <span class="property-value">
                                            <span>{{ data.shade }} Sq. Ft.</span>
                                    </span>
                                    </span>
                                </div>

                                <div class="property-param power-backup" *ngIf="(data.property_type=='1' && (data.looking_subcat_type=='5' || data.looking_subcat_type=='6'))">
                                    <span class="property-content">
                                        <span class="property-label">Power Backup</span>
                                    <span class="property-value">
                                            <span *ngIf="data.featurepowerbackup=='1'">Yes</span>
                                    <span *ngIf="data.featurepowerbackup=='0'">No</span>
                                    </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- show data for pg-->
                        <div class="col-lg-8 col-xl-8 col-md-8 col-sm-8 col-12" *ngIf="data.property_type=='3'">
                            <div class="row marginZero">
                                <div class="col-lg-9 col-xl-9 col-md-9 col-sm-9 col-12 pl-0 property-name-add">
                                    <div class="property-price">
                                        <b style="font-size:20px">{{ data.title_first }}</b>{{ data.title_second }}
                                        <h1 class="seo-none-my ">{{ data.title_first }} {{ data.title_second }}</h1>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-xl-3 col-md-3 col-sm-3 col-12 property-cta pr-0" *ngIf="!data.propertyof_user">

                                    <a style="cursor: pointer;" class="btn-small pc-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                        Now</a>

                                    <a style="cursor: pointer;" class="btn-small mobile-contact-btn" (click)="leadForm.openLeadForm()">Contact
                                        Now</a>
                                    <span class="wishlist-btn">
                                        <i class="testsss fa" id="latesetwishlist"
                                            [ngClass]="getPayingGuestWishlistId.includes(data.property_id) ? 'fa-heart':'fa-heart-o'"
                                            (click)="addToWishlist(data.property_type,data.property_id,$event)"></i>
                                        <i class="fa fa-spinner fa-spin" id="latesetloader"
                                            style="color:red;display:none"></i>
                                    </span>
                                </div>
                                <div class="col-lg-9 col-xl-9 col-md-9 col-sm-9 col-12 pl-0 property-name-add">
                                    <div class="property-price">
                                        <h4>₹{{ data.priceper_unitvalue }}</h4>
                                        <div class="title-inline-part">
                                            <span class="property-status whatsnearby" *ngIf="data.nearby_area">Near by
                                                Area: {{ data.nearby_area }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row marginZero">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-title-section">
                                    <div class="row">
                                        <div class="col-lg-8 col-xl-8 col-md-8 col-sm-7 col-12">
                                            <div class="title-inline-part"><i class="ti-calendar"></i> {{ data.created_date | date:'MMMM dd yyyy'}}</div>
                                            <div class="title-inline-part">
                                                <span class="property-whishlist-wrapper">
                                                    <a href="javascript:void(0)" class="property-whishlist">
                                                        <i class="ti-heart"></i> {{ data.total_wishlist }}
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="title-inline-part">
                                                <i class="ti-eye" aria-hidden="true"></i> {{ data.total_view }}
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-xl-4 col-md-4 col-sm-5 col-12 text-right propID align-items-center d-flex justify-content-start justify-content-sm-end">
                                            <div class="title-id"><b>Property ID:</b> {{ data.propertyid_no }}</div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row marginZero fix-third-row">
                                <div class="property-param available">
                                    <span class="property-content">
                                        <span class="property-label">Available For</span>
                                    <span class="property-value">
                                            <span *ngIf="data.gender=='1'">Male</span>
                                    <span *ngIf="data.gender=='2'">Female</span>
                                    <span *ngIf="data.gender=='3'">Unisex</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param room-type">
                                    <span class="property-content">
                                        <span class="property-label">Room</span>
                                    <span class="property-value">
                                            <span *ngIf="data.room_type=='1'">Private</span>
                                    <span *ngIf="data.room_type=='2'">Sharing</span>
                                    <span *ngIf="data.room_type=='3'">Private & Sharing</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param pgcategory">
                                    <span class="property-content">
                                        <span class="property-label">Available Category</span>
                                    <span class="property-value">
                                            <span *ngIf="data.available_category=='1'">For Professionals</span>
                                    <span *ngIf="data.available_category=='2'">For Students</span>
                                    <span *ngIf="data.available_category=='3'">For Professionals &
                                                Students</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param food">
                                    <span class="property-content">
                                        <span class="property-label">Food Availability</span>
                                    <span class="property-value">
                                            <span *ngIf="data.food_option=='1'">Available</span>
                                    <span *ngIf="data.food_option=='2'">Not Available</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param notice-period">
                                    <span class="property-content">
                                        <span class="property-label">Notice Period</span>
                                    <span class="property-value">
                                            <span class="spec-item-value" *ngIf="data.notice_period=='1'">15 Days</span>
                                    <span class="spec-item-value" *ngIf="data.notice_period=='2'">1 Month</span>
                                    <span class="spec-item-value" *ngIf="data.notice_period=='3'">2
                                                Months</span>
                                    </span>
                                    </span>
                                </div>
                                <div class="property-param attach-bath">
                                    <span class="property-content">
                                        <span class="property-label">Attached Bathroom</span>
                                    <span class="property-value">
                                            <span class="spec-item-value" *ngIf="data.attached_bathroom=='1'">Yes</span>
                                    <span class="spec-item-value" *ngIf="data.attached_bathroom=='2'">No</span>
                                    </span>
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid p-0 menu-scroll">
    <nav class="navbar navbar-expand-sm navbar-dark">
        <div class="container mp0">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div class="property-specification">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('specification')" href="#specification">Specification</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('features')" href="#features">Features</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('location')" href="#location">Location</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('site-visit')" href="#site-visit">Site Visit</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('faqs')" href="#faqs">FAQs</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="scrollTo('similar-properties')" href="#similar-properties">Similar Properties</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>

<div class="container-fluid all-info-holder">
    <!--show property detail for rent and sell-->
    <div class="container mp0" *ngIf="data.property_type=='1' || data.property_type=='2'">
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                <div class="property-specification" id="specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Specification </h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Property
                                                    Type:</span></span>
                                            <span class="spec-item-value" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2'  || data.looking_subcat_type=='4' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='10'">
                                                {{ data.looking_type_name }} {{ data.looking_subcat_type_value_name
                                                }}</span>
                                            <span class="spec-item-value" *ngIf="!(data.looking_subcat_type=='1' || data.looking_subcat_type=='2'  || data.looking_subcat_type=='4' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='10')">{{
                                                data.looking_subcat_type_name }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.looking_subcat_type=='1'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Colony/Society
                                                    Name:</span></span>
                                            <span class="spec-item-value">{{ data.project_name }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.street_no!=''">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Street
                                                    No.:</span></span>
                                            <span class="spec-item-value">{{ data.street_no }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.looking_subcat_type=='1' && data.looking_subcat_type_value>0 && data.looking_subcat_type_value!='4'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    BHK:</span></span>
                                            <span class="spec-item-value">{{ data.noof_bhk }}</span>
                                        </div>
                                    </div>
                                    <!--
                                        <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12"  *ngIf="data.looking_subcat_type>0"  >
                                            <div class="spec-item">
                                                <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Unit no./Street Name:</span></span>
                                                <span class="spec-item-value">{{ data.street_no }}</span>
                                            </div>
                                        </div>
                                    -->
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.looking_type>'0' && data.looking_subcat_type>'0'  && data.property_type=='2'  && data.looking_subcat_type!='8'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Ownership by:</span></span>
                                            <span class="spec-item-value">{{ data.property_ownership }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2'   || data.looking_subcat_type=='5' ||  data.looking_subcat_type=='6'  || data.looking_subcat_type=='9' || data.looking_subcat_type=='13')  && data.property_type=='2'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Possession
                                                    status:</span></span>
                                            <span class="spec-item-value">{{ data.possession_status_name }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='2' || data.looking_subcat_type=='4' || (data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5'  || data.looking_subcat_type=='6')) || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Area:</span></span>
                                            <span class="spec-item-value">{{ data.area }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='9'  && data.area!='')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Constructed
                                                    Area:</span></span>
                                            <span class="spec-item-value">{{ data.constructed_area }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf=" (data.looking_subcat_type=='2'  || data.looking_subcat_type=='9')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Constructed Floor:</span></span>
                                            <span class="spec-item-value">{{ data.constructed_floors=='0' ? 'Ground' :
                                                data.constructed_floors }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='4' || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Boundary:</span></span>
                                            <span class="spec-item-value" *ngIf="data.boundary=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.boundary=='0'">No</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6'))">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Super
                                                    Area:</span></span>
                                            <span class="spec-item-value">{{ data.super_area }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.property_type=='2' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6'))">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Carpet
                                                    Area:</span></span>
                                            <span class="spec-item-value">{{ data.carpet_area }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='5'  || data.looking_subcat_type=='6')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Total
                                                    Floor:</span></span>
                                            <span class="spec-item-value">{{ data.noof_floors=='0' ? 'Ground' :
                                                data.noof_floors }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='5'  || data.looking_subcat_type=='6')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Property
                                                    on Which Floor:</span></span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors=='-1'">Basement</span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors=='0'">Ground</span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors>'0'">{{
                                                data.property_which_floors }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.property_type=='1' && (data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6') && data.whichpart_torent=='2')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Floor to
                                                    Rent:</span></span>
                                            <span class="spec-item-value" *ngIf="data.floor_torent=='-1'">Basement</span>
                                            <span class="spec-item-value" *ngIf="data.floor_torent=='0'">Ground</span>
                                            <span class="spec-item-value" *ngIf="data.floor_torent>'0'">{{
                                                data.floor_torent }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="((data.looking_subcat_type=='1' || (data.property_type=='2' && (data.looking_subcat_type=='5' || data.looking_subcat_type=='6'))) && data.want_tosell=='1')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Property
                                                    on Which Floor:</span></span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors=='-1'">Basement</span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors=='0'">Ground</span>
                                            <span class="spec-item-value" *ngIf="data.property_which_floors>'0'">{{
                                                data.property_which_floors }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No of
                                                    Office:</span></span>
                                            <span class="spec-item-value">{{ data.office }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'  || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Room:</span></span>
                                            <span class="spec-item-value">{{ data.room }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='2' || data.looking_subcat_type=='9')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Kitchen:</span></span>
                                            <span class="spec-item-value">{{ data.kitchen }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Toilet:</span></span>
                                            <span class="spec-item-value">{{ data.toilet }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Shade:</span></span>
                                            <span class="spec-item-value">{{ data.shade }} Sq.Meter</span>
                                        </div>
                                    </div>

                                    <!-- this value will not show in any category -->
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='21' )">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Machinery/Plant:</span></span>
                                            <span class="spec-item-value">{{ data.machinery_plant }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='21')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Garage/Parking:</span></span>
                                            <span class="spec-item-value">{{ data.garage_parking }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Bathroom:</span></span>
                                            <span class="spec-item-value">{{ data.baathroom }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>No. of
                                                    Balcony:</span></span>
                                            <span class="spec-item-value">{{ data.balcony }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.property_type=='2' && data.possession_status=='1'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Construction
                                                    Age:</span></span>
                                            <span class="spec-item-value">{{ data.construction_age }} Years</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Price
                                                    Negociable:</span></span>
                                            <span class="spec-item-value" *ngIf="data.price_negociable=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.price_negociable=='0'">No</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Extra
                                                    Charge Apply:</span></span>
                                            <span class="spec-item-value" *ngIf="data.extra_charge_apply=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.extra_charge_apply=='0'">No</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification" id="features">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Property Features</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='2' || data.looking_subcat_type=='4' || data.looking_type=='2' || data.looking_subcat_type=='8' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Width of
                                                    Facing Road:</span></span>
                                            <span class="spec-item-value">{{ data.width_facing_road }} Foot</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9' || data.looking_subcat_type=='13')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Flooring:</span></span>
                                            <span class="spec-item-value">{{ data.flooring }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.property_type=='1' && (data.looking_subcat_type=='1' || data.looking_subcat_type=='2') ">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Rental
                                                    Allowed For:</span></span>
                                            <span class="spec-item-value">{{ data.rentalallow_for }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Corner</span></span>
                                            <span class="spec-item-value" *ngIf="data.corner=='0'">No</span>
                                            <span class="spec-item-value" *ngIf="data.corner=='1'">Yes</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Facing:</span></span>
                                            <span class="spec-item-value">{{ data.facing }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9')">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Furnishing</span></span>
                                            <span class="spec-item-value" *ngIf="data.feature_furnished=='1'">
                                                Furnished</span>
                                            <span class="spec-item-value" *ngIf="data.feature_furnished=='2'">
                                                Non-Furnished</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification" *ngIf="data.feature_furnished=='1'">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Furnished</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('1')=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Wardrobe</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('2')=='2' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Fan
                                                </span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('3')=='3' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Fridge</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('4')=='4' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Light</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('5')=='5' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Exhaust
                                                    Fan</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('6')=='6' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>TV</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('7')=='7' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Purifier</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('8')=='8' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>AC</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='6'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('9')=='9' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Pentry</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='6'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('10')=='10' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Meeting</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='6'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('11')=='11' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Work
                                                    Stations</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('12')=='12' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Modular
                                                    Kitchen</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('13')=='13' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Chimney</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('14')=='14' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Geyser</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('15')=='15' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Microwave</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('16')=='16' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Washing
                                                    Machine</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('17')=='17' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Bed</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('18')=='18' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Curtains</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('19')=='19' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Dining
                                                    Table</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('20')=='20' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Sofa</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='6' || data.looking_subcat_type=='9'">
                                        <div class="spec-item" [ngClass]="searchFeatureTypeValue('21')=='21' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Study
                                                    Table</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Common Features</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='2' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6'  || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.featurepowerbackup=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Power
                                                    Backup</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_watersupply=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Water Supply
                                                </span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_subcat_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6'  || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_lift=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Lift</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_park=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Park</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_ownparking=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Owned
                                                    Parking</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_visitparking=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Visitor
                                                    Parking</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_intercomfac=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Intercom
                                                    Facility</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9')">
                                        <div class="spec-item" [ngClass]="data.feature_swimming=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Swimming
                                                    Pool</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9')">
                                        <div class="spec-item" [ngClass]="data.feature_fitness=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Fitness
                                                    Center</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9')">
                                        <div class="spec-item" [ngClass]="data.feature_gatedcomm=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Gated
                                                    Community</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='5' || data.looking_subcat_type=='6' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9' || data.looking_subcat_type=='10' || data.looking_subcat_type=='13')">
                                        <div class="spec-item" [ngClass]="data.feature_security=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Security</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_type=='1' || data.looking_subcat_type=='7' || data.looking_subcat_type=='9')">
                                        <div class="spec-item" [ngClass]="data.feature_clubhosue=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Club
                                                    house/Community Center</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6" *ngIf="(data.looking_subcat_type=='4' || data.looking_subcat_type=='7' || data.looking_subcat_type=='8' || data.looking_subcat_type=='10')">
                                        <div class="spec-item" [ngClass]="data.feature_electricityconnection=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Electricity
                                                    Connection</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Near By Areas</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_atm=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>ATM/Bank</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_childchehe=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Child
                                                    Creche</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_shoppingmall=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Shopping
                                                    Mall</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_multiplex=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Multiplex</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_departmental=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i><span>Departmental
                                                    Store</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_school=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>School</span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_hospital=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i
                                                    class="ti-check-box"></i><span>Hospital</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification property-description">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Description</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                    <p>{{ data.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification" id="location">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Neighbourhood Places</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <ul class="nav nav-tabs filter-tabs" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link placelinks schoolnearplace" href="javascript:void(0)" (click)="findPlaces('school')">Schools</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks restaurantnearplace" href="javascript:void(0)" (click)="findPlaces('restaurant')">Restaurants</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks hospitalnearplace" href="javascript:void(0)" (click)="findPlaces('hospital')">Hospitals</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks atmnearplace" href="javascript:void(0)" (click)="findPlaces('atm')">ATMS</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks shopping_mallnearplace" href="javascript:void(0)" (click)="findPlaces('shopping_mall')">Shopping Malls</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-map-address">
                                        <!-- <div class="map-list-loader" *ngIf="mapLoader">
                                            <img alt="Please wait while loading..." style="height:140px" class="img-fluid" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/loader.gif">
                                        </div> -->

                                        <agm-map [latitude]="lat" [zoomControl]="false" [scrollwheel]="null" [disableDoubleClickZoom]="true" [longitude]="lng" [zoom]="15" [disableDefaultUI]="false" mapType='roadmap' [mapDraggable]="true" [fullscreenControl]='false' [mapTypeControl]='false'
                                            (mapReady)="setmap($event)">
                                            <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="assets/images/default_place_icon.png" (markerClick)="clickedMarker(infowindow)">
                                                <agm-info-window #infowindow>
                                                    <strong [innerHtml]="data.location"></strong>
                                                </agm-info-window>
                                            </agm-marker>

                                            <agm-marker *ngFor="let m of nearplaceList | slice:0:10" [latitude]="m.geometry.location.lat()" (markerClick)="clickedMarker(infowindow)" [longitude]="m.geometry.location.lng()">
                                                <agm-info-window #infowindow>
                                                    <strong [innerHtml]="m.name"></strong>
                                                </agm-info-window>
                                            </agm-marker>

                                        </agm-map>
                                    </div>
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-location">
                                        <div class="spec-item">
                                            <span class="label-icon" style="width:12%"><i
                                                    class="ti-arrow-circle-right"></i>Full Address:</span>
                                            <span class="spec-item-value">{{ data.location }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-location" *ngIf="data.nearby_area">
                                        <div class="spec-item">
                                            <span class="label-icon" style="width:12%"><i
                                                    class="ti-arrow-circle-right"></i>Near By Area:</span>
                                            <span class="spec-item-value">{{ data.nearby_area }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification" *ngIf="data.video">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Property Video</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                    <video width="100%" height="395" controls src="{{ data.video }}">
                                        Your browser does not support HTML5 video.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification property-description" id="site-visit" style="background: linear-gradient(-45deg,#fff,#f8cccc);padding: 15px;" *ngIf="data.sold_status==0">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2 text-center" style="border-bottom: 1px solid #c9c9c9;">
                            <h5>If you like what you see, take a visit to this property</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row align-items-center">
                                <div class="col-lg-10 col-xl-10 col-md-10 col-sm-10 col-12">
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 road-bg">
                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" src="assets/images/car.png" alt="car">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-xl-2 col-md-2 col-sm-2 col-12">
                                    <a href="javascript:void(0);" (click)="leadForm.openLeadForm()" class="btn-small" style="letter-spacing: 0;text-transform: capitalize;font-size: 14px;padding: 5px 15px;border-radius: 5px;">Request
                                        Site Visit</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification property-description" id="faqs">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>FAQs</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div id="accordion">
                                <div class="card">
                                    <div class="card-header">
                                        <a class="card-link" data-toggle="collapse" href="#collapse1">
                                            How to post a property for sale or rent?
                                        </a>
                                    </div>
                                    <div id="collapse1" class="collapse show" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Posting your property on Propira.com is free and easy. Visit Propira.com and signup, or log in to your account, then share all the details related to your property with us. Once done, relax as our qualified
                                                agents will get in touch with genuine prospects. There is no limit to the number of properties that one can post in a day or month.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                            Do you help with documentation too?
                                        </a>
                                    </div>
                                    <div id="collapse2" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Our qualified agents will help you with everything related to documentation. Also, we are there to provide support if anything seems a little out of place.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                            What documents do I need to post a property?
                                        </a>
                                    </div>
                                    <div id="collapse3" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>You will need pictures and details of your property, Propira never asks for sensitive details of its users.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                            How do you help with property purchase, sale, or rent?
                                        </a>
                                    </div>
                                    <div id="collapse4" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Propira provides you with a platform & end-to-end support to fulfill your goals related to buy, sell, and rent properties.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                            How to become a verified broker/agent with Propira?
                                        </a>
                                    </div>
                                    <div id="collapse5" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Please check the below eligibility criteria to become our authorized broker/agent.
                                            </p>
                                            <ol>
                                                <li>RERA No./ Registered Firm (Pvt. Ltd., LLP, Sole Proprietorship, Partnership, etc.)</li>
                                                <li>Proper office setup from the last five years or more</li>
                                            </ol>
                                            <p>If you fulfill the above criteria, click on the 'Apply Now' form on the website and share the below details.</p>
                                            <ol>
                                                <li>Name of Owner</li>
                                                <li>Company Name</li>
                                                <li>Registration No./ RERA No.- Attach relevant files</li>
                                                <li>No. of Employees</li>
                                                <li>Working Experience - Years</li>
                                                <li>Office Address</li>
                                                <li>Office Images</li>
                                                <li>Contact No.</li>
                                                <li>Mail ID</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse6">
                                            How to seek support, help, or contact Propira with general inquiries?
                                        </a>
                                    </div>
                                    <div id="collapse6" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Visit <a href="https://www.propira.com/contact-us" target="_blank">https://www.propira.com/contact-us</a> or mail your queries to <a href="mailto:support@propira.com" target="_blank">support@propira.com</a>                                                or click on the request a call back button on our website placed at the bottom right.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse7">
                                            What are the types of properties available on Propira?
                                        </a>
                                    </div>
                                    <div id="collapse7" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Propira can help you with all types of properties such as Residential, Commercial, Industrial, and Agricultural properties.</p>
                                            <p>The above categories include plots, condos, apartments, PGs, offices, factories, etc. Contact us to know more <a href="mailto:support@propira.com" target="_blank">support@propira.com</a> or request a call back
                                                from the button on the bottom right.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification" id="similar-properties">
                    <div class="row ">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <div class="tg-promobox">
                                <div class="tg-theme-heading">
                                    <h3>We've found similar properties for you</h3>
                                </div>
                                <p>Find the best property in Alwar by your budget</p>
                                <div class="heading-div">
                                    <i class="ti-home"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin: 0;">
                        <div *ngIf="similiarPoperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:3%">
                            <p>Property Not Found.</p>
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3 col-sm-3 col-12 pdl mp0" *ngFor="let verifyp of similiarPoperties;let i=index;">
                            <div class="propria-prop-content">
                                <a target="_blank" href="{{ verifyp.property_slug }}">
                                    <figure>
                                        <div id="demoR{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                            <div class="carousel-inner">
                                                <div class="carousel-item" *ngFor="let image of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                    <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image.img_path }}" class="img-fluid" alt="listing image" style="width: 100%">
                                                </div>
                                            </div>
                                            <a class="carousel-control-prev" href="#demoR{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                <i class="ti-angle-left"></i>
                                            </a>
                                            <a class="carousel-control-next" href="#demoR{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                <i class="ti-angle-right"></i>
                                            </a>
                                        </div>
                                        <div class="image-overlay"></div>
                                        <span class="list-loc"><i class="ti-location-pin"></i>
                                            {{verifyp.location}}</span>
                                        <span class="media-file"><i class="fa fa-play" *ngIf="verifyp.video"></i> <i
                                                class="ti-camera"></i>
                                            {{verifyp.images.length}}</span>
                                    </figure>
                                </a>
                                <div class="propria-body">
                                    <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                        {{verifyp.property_title | titlecase}} </h6>

                                    <p *ngIf="(verifyp.property_type=='2')">
                                        <b>₹{{ verifyp.priceinshort_words }}</b>&nbsp;&nbsp;
                                        <small>₹{{ verifyp.priceper_unitvalue }}</small>
                                    </p>

                                    <p *ngIf="(verifyp.property_type=='1')">
                                        <b>₹{{ verifyp.priceper_unitvalue }}</b>
                                    </p>

                                    <div class="by-build">Area: <b> {{verifyp.show_area}} </b></div>
                                    <div class="flats-catego by-build">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">See
                                            Details</a>
                                    </div>
                                    <div class="by-build">
                                        <div class="property-agent">
                                            Posted on {{verifyp.posted_date}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!--
                    <div class="property-specification">
                        <div class="row marginZero">
                            <div class="col-lg-3 col-xl-3 col-md-3 col-sm-3 col-12 p-0">
                                <h5>Virtual Tour</h5>
                            </div>
                            <div class="col-lg-9 col-xl-9 col-md-9 col-sm-9 col-12">
                                <div class="row">
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                        <iframe src="https://360player.io/p/eYr7sR/" frameborder="0" width="100%" height="315" allowfullscreen="" data-token="k6f7rb"></iframe> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
            </div>
            <!--
                <div class="col-lg-3 col-xl-3 col-md-3 col-sm-3 col-12">
                    <div class="contact-sidebar">
                        <div class="contact-holder">
                            <div class="title-holder">
                                <h5>Contact Info</h5>
                            </div>
                            <div class="contact-name">
                                <span><i class="fa fa-user"></i>The Agency </span>
                                <span><i class="fa fa-phone"></i><a href="tel:+12345678900">+12345678900</a></span>
                                <span><i class="fa fa-envelope"></i><a href="mailto:theagency@example.com">theagency@example.com </a></span>
                            </div>
                            <div class="title-holder contact-social">
                                <h5>Connect with us </h5>
                            </div>
                            <div class="contact-social-icons">
                                <a href="" target="_blank"><i class="fa fa-facebook"></i></a>
                                <a href="" target="_blank"><i class="fa fa-twitter"></i></a>
                                <a href="" target="_blank"><i class="fa fa-instagram"></i></a>
                                <a href="" target="_blank"><i class="fa fa-linkedin"></i></a>
                                <a href="" target="_blank"><i class="fa fa-pinterest"></i></a>
                            </div>
                        </div>
                    </div>
                </div>-->
        </div>
    </div>


    <!--show property detail for pg--->

    <div class="container" *ngIf="data.property_type=='3'">
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 mp0">
                <div class="property-specification" id="specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Specification</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>PG
                                                    Name:</span></span>
                                            <span class="spec-item-value">{{ data.pg_name }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Room:</span></span>
                                            <span class="spec-item-value" *ngIf="data.room_type=='1'">Private</span>
                                            <span class="spec-item-value" *ngIf="data.room_type=='2'">Sharing</span>
                                            <span class="spec-item-value" *ngIf="data.room_type=='3'">Private &
                                                Sharing</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Food:</span></span>
                                            <span class="spec-item-value" *ngIf="data.food_option=='1'">Available</span>
                                            <span class="spec-item-value" *ngIf="data.food_option=='2'">Not
                                                Available</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.food_option=='1'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Food
                                                    Type:</span></span>
                                            <span class="spec-item-value" *ngIf="data.food_type=='1'">Vegetarian</span>
                                            <span class="spec-item-value" *ngIf="data.food_type=='2'">Non
                                                Vegetarian</span>
                                            <span class="spec-item-value" *ngIf="data.food_type=='3'">Vegetarian & Non
                                                Vegetarian</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12" *ngIf="data.food_option=='1'">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Types of
                                                    Meal:</span></span>
                                            <span class="spec-item-value" *ngIf="data.food_option=='1'">{{
                                                getMealTypeName(data.meal_type) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Electrical
                                                    Charges:</span></span>
                                            <span class="spec-item-value" *ngIf="data.electrical_charges=='1'">Include</span>
                                            <span class="spec-item-value" *ngIf="data.electrical_charges=='2'">Non-Include</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Attached
                                                    Balcony:</span></span>
                                            <span class="spec-item-value" *ngIf="data.attached_balcony=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.attached_balcony=='2'">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Common
                                                    Area:</span></span>
                                            <span class="spec-item-value" *ngIf="data.common_area=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.common_area=='2'">No</span>
                                        </div>
                                    </div>



                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Smoking:</span></span>
                                            <span class="spec-item-value" *ngIf="data.smoking=='1'">Allow</span>
                                            <span class="spec-item-value" *ngIf="data.smoking=='2'">Not Allowed</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Alcohol:</span></span>
                                            <span class="spec-item-value" *ngIf="data.alcohol=='1'">Allow</span>
                                            <span class="spec-item-value" *ngIf="data.alcohol=='2'">Not Allow</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Price
                                                    Negociable:</span></span>
                                            <span class="spec-item-value" *ngIf="data.price_negociable=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.price_negociable=='0'">No</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Extra
                                                    Charge Apply:</span></span>
                                            <span class="spec-item-value" *ngIf="data.extra_charge_apply=='1'">Yes</span>
                                            <span class="spec-item-value" *ngIf="data.extra_charge_apply=='0'">No</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="property-specification" id="features">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>General Amenities</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Parking:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.genral_amenities).split(',')).includes('1')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!((data.genral_amenities).split(',')).includes('1')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Wi-Fi:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.genral_amenities).split(',')).includes('2')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!((data.genral_amenities).split(',')).includes('2')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Power
                                                    Backup:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.genral_amenities).split(',')).includes('3')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!((data.genral_amenities).split(',')).includes('3')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>House
                                                    Keeping:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.genral_amenities).split(',')).includes('4')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!((data.genral_amenities).split(',')).includes('4')">No</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Facilities</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>AC:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('2')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('2')">No</span>
                                        </div>
                                    </div>


                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Fridge:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('3')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('3')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>TV:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('1')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('1')">No</span>
                                        </div>
                                    </div>


                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Geyser:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('4')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('4')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Washing
                                                    Machine:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('5')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('5')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Purifier:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('6')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('6')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i class="ti-arrow-circle-right"></i><span>Study
                                                    Table:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('7')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('7')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Cooler:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.facilities).split(',')).includes('8')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.facilities.split(',')).includes('8')">No</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>For Stay</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Almirah:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.forstay).split(',')).includes('1')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.forstay.split(',')).includes('1')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Bed/Chairs:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.forstay).split(',')).includes('2')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.forstay.split(',')).includes('2')">No</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Common Features</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>CCTV:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.forstay).split(',')).includes('4')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.forstay.split(',')).includes('4')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Security:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.forstay).split(',')).includes('5')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.forstay.split(',')).includes('5')">No</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div class="spec-item">
                                            <span class="label-icon"><i
                                                    class="ti-arrow-circle-right"></i><span>Lift:</span></span>
                                            <span class="spec-item-value" *ngIf="((data.forstay).split(',')).includes('6')">Yes</span>
                                            <span class="spec-item-value" *ngIf="!(data.forstay.split(',')).includes('6')">No</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Near By Areas</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_atm=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>ATM/Bank</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_childchehe=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>Child Creche</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_shoppingmall=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>Shopping Mall</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_multiplex=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>Multiplex</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_departmental=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>Departmental
                                                Store</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_school=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>School</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-6">
                                        <div class="spec-item" [ngClass]="data.nearby_hospital=='1' ? 'feature-active' : 'feature-inactive'">
                                            <span class="label-icon"><i class="ti-check-box"></i>Hospital</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification property-description">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Description</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                    <p>{{ data.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification" id="location">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Neighbourhood Places</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <ul class="nav nav-tabs filter-tabs" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link placelinks schoolnearplace" href="javascript:void(0)" (click)="findPlaces('school')">Schools</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks restaurantnearplace" href="javascript:void(0)" (click)="findPlaces('restaurant')">Restaurants</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks hospitalnearplace" href="javascript:void(0)" (click)="findPlaces('hospital')">Hospitals</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks atmnearplace" href="javascript:void(0)" (click)="findPlaces('atm')">ATMS</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link placelinks shopping_mallnearplace" href="javascript:void(0)" (click)="findPlaces('shopping_mall')">Shopping Malls</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="spec">
                                <div class="row">
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-map-address">
                                        <div class="map-list-loader" *ngIf="mapLoader">
                                            <img alt="Please wait while loading..." style="height:140px" class="img-fluid" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/loader.gif">
                                        </div>

                                        <agm-map [latitude]="lat" [zoomControl]="false" [disableDoubleClickZoom]="true" [longitude]="lng" [zoom]="15" [disableDefaultUI]="false" mapType='roadmap' [scrollwheel]="null" [mapDraggable]="false" [fullscreenControl]='false' [mapTypeControl]='false'
                                            (mapReady)="setmap($event)">
                                            <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="assets/images/default_place_icon.png" (markerClick)="clickedMarker(infowindow)">
                                                <agm-info-window #infowindow>
                                                    <strong [innerHtml]="data.location"></strong>
                                                </agm-info-window>
                                            </agm-marker>

                                            <agm-marker *ngFor="let m of nearplaceList | slice:0:10" [latitude]="m.geometry.location.lat()" (markerClick)="clickedMarker(infowindow)" [longitude]="m.geometry.location.lng()">
                                                <agm-info-window #infowindow>
                                                    <strong [innerHtml]="m.name"></strong>
                                                </agm-info-window>
                                            </agm-marker>

                                        </agm-map>
                                    </div>
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-location">
                                        <div class="spec-item">
                                            <span class="label-icon" style="width:12%"><i
                                                    class="ti-arrow-circle-right"></i>Full Address:</span>
                                            <span class="spec-item-value">{{ data.location }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 property-location" *ngIf="data.nearby_area">
                                        <div class="spec-item">
                                            <span class="label-icon" style="width:12%"><i
                                                    class="ti-arrow-circle-right"></i>Near By Area:</span>
                                            <span class="spec-item-value">{{ data.nearby_area }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification" *ngIf="data.video">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>Property Video</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                    <video width="100%" controls src="{{ data.video }}">
                                        Your browser does not support HTML5 video.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="property-specification property-description" id="site-visit" style="background: linear-gradient(-45deg,#fff,#f8cccc);padding: 15px;">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2 text-center" style="border-bottom: 1px solid #c9c9c9;">
                            <h5>If you like what you see, take a visit to this property</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="row align-items-center">
                                <div class="col-lg-10 col-xl-10 col-md-10 col-sm-10 col-12">
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 road-bg">
                                        <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/car.png" alt="car">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-xl-2 col-md-2 col-sm-2 col-12">
                                    <a href="javascript:void(0);" (click)="leadForm.openLeadForm()" class="btn-small" style="letter-spacing: 0;text-transform: capitalize;font-size: 14px;padding: 5px 15px;border-radius: 5px;">Request
                                        Site Visit</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification property-description" id="faqs">
                    <div class="row marginZero">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                            <h5>FAQs</h5>
                        </div>
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div id="accordion">
                                <div class="card">
                                    <div class="card-header">
                                        <a class="card-link" data-toggle="collapse" href="#collapse1">
                                            How to post a property for sale or rent?
                                        </a>
                                    </div>
                                    <div id="collapse1" class="collapse show" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Posting your property on Propira.com is free and easy. Visit Propira.com and signup, or log in to your account, then share all the details related to your property with us. Once done, relax as our qualified
                                                agents will get in touch with genuine prospects. There is no limit to the number of properties that one can post in a day or month.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                            Do you help with documentation too?
                                        </a>
                                    </div>
                                    <div id="collapse2" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Our qualified agents will help you with everything related to documentation. Also, we are there to provide support if anything seems a little out of place.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                            What documents do I need to post a property?
                                        </a>
                                    </div>
                                    <div id="collapse3" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>You will need pictures and details of your property, Propira never asks for sensitive details of its users.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                            How do you help with property purchase, sale, or rent?
                                        </a>
                                    </div>
                                    <div id="collapse4" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Propira provides you with a platform & end-to-end support to fulfill your goals related to buy, sell, and rent properties.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                            How to become a verified broker/agent with Propira?
                                        </a>
                                    </div>
                                    <div id="collapse5" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Please check the below eligibility criteria to become our authorized broker/agent.
                                            </p>
                                            <ol>
                                                <li>RERA No./ Registered Firm (Pvt. Ltd., LLP, Sole Proprietorship, Partnership, etc.)</li>
                                                <li>Proper office setup from the last five years or more</li>
                                            </ol>
                                            <p>If you fulfill the above criteria, click on the 'Apply Now' form on the website and share the below details.</p>
                                            <ol>
                                                <li>Name of Owner</li>
                                                <li>Company Name</li>
                                                <li>Registration No./ RERA No.- Attach relevant files</li>
                                                <li>No. of Employees</li>
                                                <li>Working Experience - Years</li>
                                                <li>Office Address</li>
                                                <li>Office Images</li>
                                                <li>Contact No.</li>
                                                <li>Mail ID</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse6">
                                            How to seek support, help, or contact Propira with general inquiries?
                                        </a>
                                    </div>
                                    <div id="collapse6" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Visit <a href="https://www.propira.com/contact-us" target="_blank">https://www.propira.com/contact-us</a> or mail your queries to <a href="mailto:support@propira.com" target="_blank">support@propira.com</a>                                                or click on the request a call back button on our website placed at the bottom right.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <a class="collapsed card-link" data-toggle="collapse" href="#collapse7">
                                            What are the types of properties available on Propira?
                                        </a>
                                    </div>
                                    <div id="collapse7" class="collapse" data-parent="#accordion">
                                        <div class="card-body">
                                            <p>Propira can help you with all types of properties such as Residential, Commercial, Industrial, and Agricultural properties.</p>
                                            <p>The above categories include plots, condos, apartments, PGs, offices, factories, etc. Contact us to know more <a href="mailto:support@propira.com" target="_blank">info@propira.com</a> or request a call back
                                                from the button on the bottom right.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="property-specification" id="similar-properties">
                    <div class="row ">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                            <div class="tg-promobox">
                                <div class="tg-theme-heading">
                                    <h3>We've found similar properties for you</h3>
                                </div>
                                <p>Find the best property in Alwar by your budget</p>
                                <div class="heading-div">
                                    <i class="ti-home"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pdd-0">
                        <div *ngIf="similiarPoperties.length==0" class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 text-center" style="margin-top:3%">
                            <p>Property Not Found.</p>
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3 col-sm-3 col-12 pdl mp0" *ngFor="let verifyp of similiarPoperties;let i=index;">
                            <div class="propria-prop-content">
                                <a target="_blank" href="{{ verifyp.property_slug }}">
                                    <figure>
                                        <div id="demoR{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                            <div class="carousel-inner">
                                                <div class="carousel-item" *ngFor="let images of verifyp.images;let first=first;" [ngClass]="{active: first}">
                                                    <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ images.img_path }}" class="img-fluid" alt="listing image" style="width: 100%">
                                                </div>
                                            </div>
                                            <a class="carousel-control-prev" href="#demoR{{i}}" data-slide="prev" *ngIf="verifyp.images.length>1">
                                                <i class="ti-angle-left"></i>
                                            </a>
                                            <a class="carousel-control-next" href="#demoR{{i}}" data-slide="next" *ngIf="verifyp.images.length>1">
                                                <i class="ti-angle-right"></i>
                                            </a>
                                        </div>
                                        <div class="image-overlay"></div>
                                        <span class="list-loc"><i class="ti-location-pin"></i>
                                            {{verifyp.location}}</span>
                                        <span class="media-file"> <i class="ti-camera"></i>
                                            {{verifyp.images.length}}</span>
                                    </figure>
                                </a>
                                <div class="propria-body">
                                    <a target="_blank" href="{{ verifyp.property_slug }}">
                                        <h6 class="names-propria" data-toggle="tooltip" data-placement="left" title="{{verifyp.property_title | titlecase}}">
                                            {{verifyp.property_title | titlecase}} </h6>
                                    </a>
                                    <p><b>₹{{verifyp.priceper_unitvalue}}/Monthly</b>
                                    </p>
                                    <div class="flats-catego by-build">
                                        <a target="_blank" href="{{ verifyp.property_slug }}">See
                                            Details</a>
                                    </div>
                                    <div class="by-build">
                                        <div class="property-agent">
                                            Posted on {{verifyp.posted_date}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual blog-bg bgGray">
    <div class="container">
        <div class="row ">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                <div class="tg-promobox ">
                    <div class="tg-theme-heading">
                        <h3>Our Latest Blog</h3>
                    </div>
                    <p>Take a deep dive and browse original neighborhood photos, drone footage, resident reviews and local insights to see if the homes for sale are right for you.</p>
                    <div class="heading-div">
                        <i class="ti-home"></i>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="min-outer-view" style="text-align:right; margin-bottom: 10px;">
                    <a class="text-dark viewAllBtn" routerLink="/blog">
                        <span>View All</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="blog-box">
            <div class="latest-blog">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 pdl mp0" *ngFor="let blog of blogList;let last=last">
                    <a routerLink="/blog/{{blog.slug}}">
                        <div class="propira-blog">
                            <figure>
                                <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{blog.image}}" class="img-fluid" alt="listing image">
                            </figure>
                            <div class="blog-body">
                                <h6>{{blog.blog_title}}</h6>
                                <p class="blog-text">
                                    {{ ((blog.short_description).length>90)? (blog.short_description | slice:0:90)+'..':(blog.short_description) }}
                                </p>
                                <p><span class="blog-btn">Read More</span>
                                    <span><i class="ti-calendar"></i> {{blog.date}}</span>
                                    <span><i class="ti-user"></i> {{blog.author_name}}</span>
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <!-- <div class="min-outer-view" style="text-align:center;margin-top:4%;">
            <a routerLink="/blog">
                <span>View All</span>
            </a>
        </div> -->
    </div>
</div>

<!---Lead Form-->
<app-leadform property_id="{{data.property_id}}" #leadForm [leadTableName]="leadTableName"></app-leadform>